import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;

  ul.ant-menu {
    background: #f2f2f2;
    border: 0 !important;

    li {
      &.ant-menu-item {
        height: 52px;
        line-height: 52px;
        margin: 0;
        width: 100%;
        display: flex;
        align-items: center;

        &:hover {
          background: #dedede;
        }

        svg {
          min-width: 26px;
          min-height: 26px;
          width: 26px;
          height: 26px;
          
          path {
            fill: #8C8C8C;
          }
        }

        span {
          color: #8C8C8C;
        }

        &.ant-menu-item-active {
          background: #e8e8e8;
        }

        &.ant-menu-item-selected {
          border-left: 2px solid ${themeColors.character.primary85};
          background: #f2f2f2;

          svg {
            path {
              fill: ${themeColors.character.primary85};
            }
          }

          span {
            color: ${themeColors.character.primary85};
          }
        }
      }
      
      &.ant-menu-submenu {
        .ant-menu-submenu-title {
          height: 52px;
          line-height: 52px;
          margin: 0;
          width: 100%;
          color: #8C8C8C;
          display: flex;
          align-items: center;
          
          &:hover {
            color: #8C8C8C;
          }
          
          svg {
            min-width: 26px;
            min-height: 26px;
            width: 26px;
            height: 26px;
          }
        }
        
        .ant-menu-sub.ant-menu-inline {
          background: transparent;
        }
        
        &.ant-menu-submenu-open {
          background: #E4E4E4;
        }
        
        &.ant-menu-submenu-selected {
          .ant-menu-submenu-title {
            border-left: 2px solid ${themeColors.character.primary85};
            color: ${themeColors.character.primary85};
            
            svg {
              path {
                fill: ${themeColors.character.primary85};
              }
            }
          }
          
          .ant-menu-item-selected {
            border-left: 0;
            background: rgba(0, 0, 0, 0.06);;
          }
        }
      }
    }
  }
`;


// #E4E4E4
